// @flow
import React, { Fragment } from "react";
import { attempt } from "lodash";
import SplashLoader from "@fdr/atomic-ui/_templates/SplashLoader";

type Props = {
  messages: {
    splashLoadMessages: {
      default: {
        title: string,
        subTitle: string
      }
    },
    error: {
      title: string,
      subTitle: string
    }
  }
};

export const SplashLoaderComponent = ({ messages }: Props) => {
  const splashMessages = attempt(JSON.parse, [messages.splashLoadMessages]);

  return (
    <Fragment>
      <SplashLoader
        percent={typeof window === "undefined" ? 0 : 100}
        messages={splashMessages}
        isVisible={false}
      />
      <SplashLoader
        percent={typeof window === "undefined" ? 0 : 100}
        messages={splashMessages}
        isVisible={false}
        isError
      />
    </Fragment>
  );
};

SplashLoaderComponent.defaultProps = {
  messages: {}
};

export default SplashLoaderComponent;
